type Props = {
  code: string
  testId?: string
}

const ColorBubble = ({ code, testId }: Props) => (
  <div
    className={`catalog-color-select__value catalog-color-select__value--${code.toLowerCase()}`}
    data-testid={testId}
  />
)

export default ColorBubble
